import type { TopUpState } from '../types';

export const CREDITS_QUERY_KEY = 'credits';
export const CREDITS_TAB_ID = 'credits';
export const PLAN_REQUEST_QUERY_KEY = 'plan-request';
/** The meter a plan's monthly AI allowance is counted on. */
export const AI_CREDITS_METER = 'ai-credits';

export const DEFAULT_PRESETS_CHF = [10, 25, 50, 100];
export const MAX_AMOUNT_DECIMALS = 2;
export const HISTORY_PAGE_SIZE = 10;

export const TOP_UP_POLL_INTERVAL_MS = 2000;
export const TOP_UP_POLL_TIMEOUT_MS = 60000;

export const FINAL_TOP_UP_STATES: TopUpState[] = ['Paid', 'Failed', 'Cancelled', 'Expired'];

export const CREDITS_ERROR = {
  billingIncomplete: 'billing_profile_incomplete',
  amountTooSmall: 'amount_too_small',
  amountTooLarge: 'amount_too_large',
  cardDeclined: 'card_declined',
  paymentUnavailable: 'payment_unavailable',
  paymentForbidden: 'payment_forbidden',
  providerMissing: 'payment_provider_missing',
  creditsEmpty: 'credits_empty',
  couponNotFound: 'coupon_not_found',
  couponNotStarted: 'coupon_not_started',
  couponExpired: 'coupon_expired',
  couponNotApplicable: 'coupon_not_applicable',
  couponAlreadyUsed: 'coupon_already_used',
  couponExhausted: 'coupon_exhausted',
  couponInUse: 'coupon_in_use',
  payableBelowMinimum: 'payable_below_minimum',
} as const;

export const USAGE_LIMIT_CATEGORY = 'usage_limit';
